import api from './api';
import type { OtroItemDto, OtroItemCreateRequest } from '@/types/otroItem';

export const otrosItemsApi = {
  findAll: () => api.get<OtroItemDto[]>('/otros-items').then((r) => r.data),

  search: (q: string) =>
    api.get<OtroItemDto[]>('/otros-items', { params: { q } }).then((r) => r.data),

  findById: (id: number) =>
    api.get<OtroItemDto>(`/otros-items/${id}`).then((r) => r.data),

  create: (data: OtroItemCreateRequest) =>
    api.post<OtroItemDto>('/otros-items', data).then((r) => r.data),

  update: (id: number, data: OtroItemCreateRequest) =>
    api.put<OtroItemDto>(`/otros-items/${id}`, data).then((r) => r.data),

  uploadImage: (id: number, formData: FormData) =>
    api
      .post<OtroItemDto>(`/otros-items/${id}/imagen`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data),

  delete: (id: number) => api.delete(`/otros-items/${id}`),
};
